import { useEffect, useState, type MutableRefObject } from "react";
import type { AgentsSnapshot, PairingClient } from "../protocol";

const EMPTY: AgentsSnapshot = { workflows: [], subagents: [] };

/** The selected session's workflow runs and sub-agents. Resubscribes when the selection changes. */
export function useSessionAgents(
  clients: MutableRefObject<Map<string, PairingClient>>,
  selected: string | null,
  clientsVersion: number,
): AgentsSnapshot {
  const [agents, setAgents] = useState<AgentsSnapshot>(EMPTY);
  useEffect(() => {
    setAgents(EMPTY);
    if (!selected) return;
    const [pid, sid] = selected.split("/");
    const unsub = clients.current.get(pid)?.subscribeAgents(sid, setAgents);
    return () => unsub?.();
  }, [selected, clientsVersion]);
  return agents;
}
